<template>
  <div class="station-furnace-bed-list">
    <div v-for="(bed, index) of bedList" :key="index" class="station-furnace-bed-preview" :style="{'flex': bedFlexHeight}" @click.prevent="bedClicked(bed.index)">
      <div :class="{'station-furnace-bed-contents': true, 'active': currentBedIndex == bed.index}">
        <h2>{{bed.name}}</h2>
        <div v-if="bed.panelCount > 0">
          <h1>{{bed.panelCount}}</h1>
          <div class="text-center">Panel{{bed.panelCount | displayCountPlural}}</div>
        </div>
        <div v-if="bed.panelCount > 0 && isLoadingBed(bed.index) && bed.yieldPercent > 0">
          <h3 :class="['bed-yield', calculateBedYieldBadgeClass(bed.yieldPercent)]">{{formatInteger(bed.yieldPercent)}}% Yield</h3>
        </div>
        <div v-if="bed.hasSamplePiece">
          <h3 class="bed-sample label-production-toughening-sample">Contains Sample</h3>
        </div>
        <div v-if="bed.panelCount == 0 && !bed.hasSamplePiece" class="mt-4">
          Empty
        </div>
        <button v-if="(bed.panelCount > 0 || bed.hasSamplePiece) && !isUnloadingBed(bed.index) && canControlBeds" class="btn btn-primary furnace-advance-button" :disabled="advancedBedDisabled" @click.prevent="clickAdvanceBed(bed.index)">
          <i class="fas fa-step-forward mr-3"></i> Advance {{bedName(bed.index)}} Bed
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$bed-active-colour: #2FB2E6;

.station-furnace-bed-list {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #333333;
}
.station-furnace-bed-preview {
  padding: 0px 0px 0px 5px;  
  cursor: pointer;
}
.station-furnace-bed-preview:not(:last-child) {
  padding-bottom: 5px;
}
.station-furnace-bed-contents {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #212121;
  padding: 1rem;
}
.station-furnace-bed-contents.active {
  border: 1px solid $bed-active-colour;
}
.station-furnace-bed-contents > h2 {
  text-transform: uppercase;
  margin: 0;
  color: #909090;
}
.bed-sample {
  margin-top: 6px;
  border-radius: 6px;
  padding: 4px;
}
.bed-yield {
  margin-top: 4px;
  border-radius: 6px;
  padding: 2px;
  color: #212121;
}
.bed-yield.bed-yield-bad {
  background-color: $chart-colour-bad;
}
.bed-yield.bed-yield-medium {
  background-color: $chart-colour-medium;
}
.bed-yield.bed-yield-good {
  background-color: $chart-colour-good;
}
.station-furnace-bed-contents.active > h2 {
  color: inherit;
}
.station-furnace-bed-highlight {
  color: $bed-active-colour;
}
.station-furnace-bed-contents h1 {
  color: $bed-active-colour;
  text-align: center;
  font-weight: bold;
  font-size: 4rem;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
}
.station-furnace-bed-contents > div {
  text-align: center;
  font-weight: bold;
}

.furnace-advance-button {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 10px;
  font-size: 1rem;
  border-radius: 0;
}


</style>

<script>
export default {
  name: 'FurnaceBedDisplay',
  props: {
    bedList: Array,
    currentBedIndex: {
      type: Number,
      default: 0
    },
    canControlBeds: {
      type: Boolean,
      default: true
    },
    advancedBedDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bedFlexHeight() {
      if(this.bedList.length == 0)
        return '1%'
      return Math.round(100.0 / this.bedList.length) + '%'
    }
  },
  methods: {
    bedClicked(bedIndex) {
      this.$emit('bedClick', bedIndex)
    },
    isLoadingBed(index) {
      return index == 0
    },
    isWaitingBed(index) {
      return index == 1
    },
    isUnloadingBed(index) {
      return index == 2
    },
    bedName(index) {
      switch(index) {
        case 0:
          return 'Loading'
        case 1:
          return 'Waiting'
        case 2:
          return 'Unloading'
      }
    },
    clickAdvanceBed(index) {
      this.$emit('advanceBed', index)
    },
    calculateBedYieldBadgeClass(yieldPercent) {
      if(yieldPercent < 33)
        return 'bed-yield-bad'
      else if(yieldPercent < 66)
        return 'bed-yield-medium'
      return 'bed-yield-good'
    }
  }


}
</script>